/* DOSSARD — code vidéo, filtres, fiche produit, panier. Aucun framework. */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const pad = (v) => String(v).padStart(2, '0');
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Catalogue (numéro → t-shirt) ---------- */
  let catalog = [];
  try { catalog = JSON.parse(($('#dossard-catalog') || {}).textContent || '[]'); } catch (e) { catalog = []; }
  const find = (raw) => {
    const digits = String(raw || '').replace(/\D/g, '');
    if (!digits) return null;
    const n = pad(Number(digits));
    return catalog.find((p) => p.n === n) || null;
  };

  /* ---------- Drop : réglages et numéros des drops terminés ---------- */
  let drop = {};
  try { drop = JSON.parse(($('#dossard-drop') || {}).textContent || '{}'); } catch (e) { drop = {}; }
  const pastNumbers = new Set();
  String(drop.past || '').split(',').forEach((part) => {
    const m = part.trim().match(/^(\d+)(?:\s*-\s*(\d+))?$/);
    if (!m) return;
    const a = Number(m[1]);
    const b = m[2] ? Number(m[2]) : a;
    for (let i = Math.min(a, b); i <= Math.max(a, b); i++) pastNumbers.add(pad(i));
  });
  const isPast = (digits) => digits.length >= 1 && pastNumbers.has(pad(Number(digits)));

  /* ---------- Drop : le compte à rebours (accueil) et la ligne du drop (fiche produit) ---------- */
  $$('[data-drop-board]').forEach((board) => {
    const end = Date.parse(board.dataset.end || '');
    if (!end) return; // drop pas encore lancé : le compteur affiche la durée totale
    const compact = 'compact' in board.dataset;
    const name = board.dataset.name || drop.name || 'Le drop';
    const line = $('[data-drop-line]', board);
    const label = $('[data-blaze-label]', board);
    const timer = $('[data-blaze]', board);
    const digits = Object.fromEntries(['d', 'h', 'm', 's'].map((k) => [k, $(`[data-u="${k}"]`, board)]));
    const show = (k, v) => {
      const el = digits[k];
      if (!el || el.textContent === v) return;
      el.textContent = v;
      el.classList.remove('is-tick');
      void el.offsetWidth; // relance l'animation du chiffre qui tombe
      el.classList.add('is-tick');
    };
    let said = '';
    const say = (text) => { if (timer && text !== said) { timer.setAttribute('aria-label', text); said = text; } };
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) {
        board.classList.add('is-over');
        board.classList.remove('is-final');
        ['d', 'h', 'm', 's'].forEach((k) => show(k, '00'));
        if (label) label.textContent = `${name} terminé`;
        say(`${name} terminé`);
        if (line) line.textContent = `${name} terminé`;
        return false;
      }
      const s = Math.floor(left / 1000);
      const d = Math.floor(s / 86400);
      const h = Math.floor((s % 86400) / 3600);
      const m = Math.floor((s % 3600) / 60);
      const final = left < 72 * 3600 * 1000;
      show('d', pad(d)); show('h', pad(h)); show('m', pad(m)); show('s', pad(s % 60));
      if (label) label.textContent = final ? 'Dernières heures' : 'Disparaît dans';
      const n = (v, w) => `${v} ${w}${v > 1 ? 's' : ''}`;
      say(`${name} disparaît dans ${n(d, 'jour')}, ${n(h, 'heure')} et ${n(m, 'minute')}`);
      if (line) line.textContent = `${name} · ferme dans ${d > 0 ? `${d} j ` : ''}${pad(h)} h ${pad(m)}`;
      board.classList.toggle('is-final', final);
      return true;
    };
    if (tick()) {
      const id = setInterval(() => { if (!tick()) clearInterval(id); }, compact ? 20000 : 1000);
    }
  });

  /* ---------- Toast ---------- */
  const toast = $('.toast');
  let toastTimer;
  function showToast(text, withLink = true) {
    if (!toast) return;
    $('.toast__text', toast).textContent = text;
    $('.toast__link', toast).hidden = !withLink;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 4200);
  }

  /* ---------- Lien direct : /?n=07 envoie sur le t-shirt ---------- */
  const params = new URLSearchParams(location.search);
  const asked = params.get('n');
  const askedHit = asked ? find(asked) : null;
  if (askedHit) {
    location.replace(askedHit.url);
    return;
  }

  /* ---------- Champs « code vidéo » ---------- */
  const bib = $('[data-bib]');
  const bibInput = $('[data-code-main]');
  const bibStatus = $('[data-bib-status]');
  const matchBox = $('[data-match]');
  const defaultStatus = bibStatus ? bibStatus.textContent : '';

  function highlightCard(n) {
    $$('.card.is-hit').forEach((c) => c.classList.remove('is-hit'));
    if (n) $$(`.card[data-n="${n}"]`).forEach((c) => c.classList.add('is-hit'));
  }

  function renderMatch(value) {
    if (!bib) return;
    const digits = value.replace(/\D/g, '');
    const hit = find(digits);
    bib.classList.remove('is-hit', 'is-miss');
    if (!digits) {
      bibStatus.textContent = defaultStatus;
      matchBox.innerHTML = '';
      highlightCard(null);
      return;
    }
    if (hit) {
      bib.classList.add('is-hit');
      bibStatus.textContent = `N°${hit.n} trouvé`;
      matchBox.innerHTML = `
        <a class="match__card" href="${esc(hit.url)}">
          ${hit.img ? `<img src="${esc(hit.img)}" alt="" width="72" height="72">` : '<span></span>'}
          <span class="match__txt">
            <span class="match__meta">N°${esc(hit.n)}${hit.cat ? ' · ' + esc(hit.cat) : ''}</span>
            <span class="match__name">${esc(hit.name)}</span>
            <span class="match__price">${esc(hit.price)}</span>
          </span>
          <span class="match__go">Voir →</span>
        </a>`;
      highlightCard(hit.n);
    } else if (digits.length >= 2 || digits === '0') {
      if (digits.length >= 2) {
        void bib.offsetWidth;
        bib.classList.add('is-miss');
      }
      const past = isPast(digits);
      bibStatus.textContent = digits.length >= 2 ? (past ? `N°${pad(digits)} : drop terminé` : `Pas de N°${pad(digits)} ici`) : defaultStatus;
      matchBox.innerHTML = digits.length >= 2
        ? (past
          ? `<p class="match__none">Le N°${esc(pad(digits))} faisait partie d’un drop terminé : il n’est plus imprimé. <a href="${root}pages/coups-de-coeur">Les coups de cœur</a> sont restés, et <a href="#drop">le drop en cours ↓</a> t’attend.</p>`
          : `<p class="match__none">Aucun N°${esc(pad(digits))} dans ce drop. Revérifie la vidéo, ou <a href="#drop">fouille le drop ↓</a></p>`)
        : '';
      highlightCard(null);
    }
  }

  $$('[data-code-input]').forEach((input) => {
    input.addEventListener('input', () => {
      const clean = input.value.replace(/\D/g, '').slice(0, 2);
      if (clean !== input.value) input.value = clean;
      if (input === bibInput) renderMatch(clean);
    });
  });

  $$('[data-code-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = $('[data-code-input]', form);
      const hit = find(input.value);
      if (hit) {
        location.href = hit.url;
        return;
      }
      form.classList.remove('is-miss');
      void form.offsetWidth;
      form.classList.add('is-miss');
      if (form !== bib) {
        const v = input.value.replace(/\D/g, '');
        showToast(v ? (isPast(v) ? `N°${pad(v)} : son drop est terminé` : `Aucun N°${pad(v)} dans ce drop`) : 'Tape un numéro', false);
      }
      input.focus();
    });
  });

  if (bibInput && asked) {
    bibInput.value = asked.replace(/\D/g, '').slice(0, 2);
    renderMatch(bibInput.value);
  }

  /* ---------- Filtres du drop ---------- */
  const chips = $('[data-chips]');
  if (chips) {
    const cards = $$('[data-grid] .card');
    const count = $('[data-drop-count]');
    chips.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-filter]');
      if (!chip) return;
      const f = chip.dataset.filter;
      $$('[data-filter]', chips).forEach((c) => {
        const on = c === chip;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      let shown = 0;
      cards.forEach((card) => {
        const keep = !f || card.dataset.cat === f;
        card.hidden = !keep;
        if (keep) shown++;
      });
      if (count) count.textContent = shown;
    });
  }

  /* ---------- Panier : compteur ---------- */
  async function refreshCount() {
    try {
      const res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      });
    } catch (e) { /* le compteur se mettra à jour au prochain chargement */ }
  }

  /* ---------- Fiche produit ---------- */
  const product = $('[data-product]');
  if (product) {
    const form = $('[data-product-form]', product);
    const idInput = $('[data-variant-id]', form);
    const variants = JSON.parse(($('[data-variants]', product) || {}).textContent || '[]');
    const optionSets = $$('[data-option]', form);
    const perso = $('[data-perso-input]', form);
    const errorBox = $('[data-form-error]', form);
    const buyBtn = $('[data-buy-now]', form);
    const addBtn = $('[data-add-to-cart]', form);
    const money = (cents) => {
      const v = cents / 100;
      return (Number.isInteger(v) ? String(v) : v.toFixed(2).replace('.', ',')) + ' €';
    };

    function selectedOptions() {
      return optionSets.map((set) => {
        const checked = $('input:checked', set);
        return checked ? checked.value : null;
      });
    }

    function syncVariant() {
      const opts = selectedOptions();
      if (opts.some((o) => o === null)) return null;
      const v = variants.find((variant) => variant.options.every((o, i) => o === opts[i]));
      if (!v) return null;
      idInput.value = v.id;
      $$('[data-price]').forEach((el) => { el.textContent = money(v.price); });
      $$('[data-btn-price]').forEach((el) => { el.textContent = money(v.price); });
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
      return v;
    }

    optionSets.forEach((set) => {
      set.addEventListener('change', () => {
        set.classList.remove('is-missing');
        errorBox.hidden = true;
        syncVariant();
      });
    });

    if (perso) {
      perso.addEventListener('input', () => {
        const clean = perso.value.toUpperCase().replace(/[^A-ZÀ-ÖØ-Ý' -]/g, '').slice(0, 12);
        if (clean !== perso.value) perso.value = clean;
        perso.closest('.perso').classList.remove('is-missing');
        errorBox.hidden = true;
      });
    }

    function validate() {
      let firstBad = null;
      optionSets.forEach((set) => {
        if (!$('input:checked', set)) {
          set.classList.remove('is-missing');
          void set.offsetWidth;
          set.classList.add('is-missing');
          firstBad = firstBad || set;
        }
      });
      if (perso && !perso.value.trim()) {
        const box = perso.closest('.perso');
        box.classList.remove('is-missing');
        void box.offsetWidth;
        box.classList.add('is-missing');
        firstBad = firstBad || box;
      }
      if (firstBad) {
        errorBox.textContent = optionSets.some((s) => !$('input:checked', s))
          ? 'Choisis ta taille.'
          : 'Écris le prénom à imprimer.';
        errorBox.hidden = false;
        firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      if (optionSets.length && !syncVariant()) {
        errorBox.textContent = 'Cette taille n’est pas disponible.';
        errorBox.hidden = false;
        return false;
      }
      return Boolean(idInput.value);
    }

    async function addToCart() {
      const body = { items: [{ id: Number(idInput.value), quantity: 1 }] };
      if (perso) body.items[0].properties = { [perso.name.replace(/^properties\[|\]$/g, '')]: perso.value.trim() };
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || 'Impossible d’ajouter ce t-shirt pour le moment.');
      }
      return res.json();
    }

    async function run(btn, thenCheckout) {
      if (!validate()) return;
      btn.classList.add('is-busy');
      try {
        await addToCart();
        if (thenCheckout) {
          location.href = root + 'checkout';
          return;
        }
        await refreshCount();
        const size = selectedOptions().filter(Boolean).join(' · ');
        const num = ($('.buybar__n', product) || {}).textContent || '';
        showToast(`Ajouté : ${num}${size ? ' · ' + size : ''}`);
      } catch (err) {
        errorBox.textContent = err.message;
        errorBox.hidden = false;
      } finally {
        btn.classList.remove('is-busy');
      }
    }

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      run(buyBtn, true);
    });
    addBtn.addEventListener('click', () => run(addBtn, false));

    if (idInput.value) syncVariant();

    /* Galerie */
    const track = $('[data-gallery-track]', product);
    const counter = $('[data-gallery-count]', product);
    const thumbs = $$('[data-thumbs] button', product);
    if (track) {
      const total = track.children.length;
      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          if (counter) counter.textContent = `${i + 1} / ${total}`;
          thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
          ticking = false;
        });
      }, { passive: true });
      thumbs.forEach((t) => {
        t.addEventListener('click', () => {
          track.scrollTo({ left: track.clientWidth * Number(t.dataset.index), behavior: 'smooth' });
        });
      });
    }

    /* Guide des tailles */
    const guide = $('[data-guide]', product);
    $$('[data-open-guide]', product).forEach((b) => {
      b.addEventListener('click', () => {
        if (!guide) return;
        guide.open = true;
        guide.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* Barre d'achat collante (mobile) */
    const buybar = $('[data-buybar]', product);
    const actions = $('[data-actions]', product);
    if (buybar && actions && 'IntersectionObserver' in window) {
      const btn = $('[data-buybar-btn]', buybar);
      new IntersectionObserver(([entry]) => {
        const on = !entry.isIntersecting;
        buybar.classList.toggle('is-on', on);
        buybar.setAttribute('aria-hidden', on ? 'false' : 'true');
        btn.tabIndex = on ? 0 : -1;
      }, { rootMargin: '0px 0px -40px 0px' }).observe(actions);
      btn.addEventListener('click', () => {
        if (validate()) run(btn, true);
      });
    }
  }

  /* ---------- Page panier : quantités ---------- */
  const cartForm = $('[data-cart-form]');
  if (cartForm) {
    let t;
    const submit = () => { clearTimeout(t); t = setTimeout(() => cartForm.requestSubmit ? cartForm.requestSubmit() : cartForm.submit(), 350); };
    cartForm.addEventListener('click', (e) => {
      const step = e.target.closest('[data-qty-step]');
      if (!step) return;
      const input = $('[data-qty-input]', step.parentElement);
      input.value = Math.max(0, Number(input.value || 0) + Number(step.dataset.qtyStep));
      submit();
    });
    $$('[data-qty-input]', cartForm).forEach((input) => input.addEventListener('change', submit));
  }
})();
